import { Get } from "./api";

export const getAPFT = async () => {
  const result = await Get('/api/apft');

  return result.data;
};
